const o = {
  container: "#toolbar"
}, n = {
  bindings: {
    indent: {
      key: "tab",
      format: ["list"],
      handler() {
        var t;
        (t = this.quill) == null || t.format("indent", "+1", "user");
      }
    }
  }
}, i = {
  delay: 500,
  maxStack: 500
}, s = [
  "bold",
  "italic",
  "underline",
  "strike",
  "list",
  "image",
  "link",
  "indent"
], a = {
  toolbar: o,
  keyboard: n,
  history: i
};
export {
  s as formats,
  a as modules
};
